import opsFilter from "./opsFilter"

export default function() {
  return {
    fn: {
      opsFilter
    }
  }
}



// WEBPACK FOOTER //
// ./src/core/plugins/filter/index.js